import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { GripVertical } from 'lucide-react';

interface SortableSidebarItemProps {
    id: string;
    children: React.ReactNode;
}

export function SortableSidebarItem({ id, children }: SortableSidebarItemProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id });

    const style = {
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging ? 50 : 'auto',
        position: isDragging ? 'relative' as const : undefined,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`flex items-center gap-1 rounded-xl group transition-all ${
                isDragging ? 'opacity-50 bg-slate-100 shadow-md' : ''
            }`}
        >
            <div 
                className="p-1 cursor-grab text-slate-300 hover:text-slate-500 active:cursor-grabbing shrink-0 flex items-center justify-center" 
                style={{ touchAction: 'none' }} 
                {...attributes} 
                {...listeners}
            >
                <GripVertical size={12} />
            </div>
            <div className="flex-1 min-w-0">
                {children}
            </div>
        </div>
    );
}
